import * as React from "react";

function CapacityBuildingIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={39} height={39} viewBox="0 0 39 39" {...props}>
      <circle cx="19.5" cy="19.5" r="19" fill="#4cd5c5" />
      <path
        d="M27 19h-5v-5h-4v5h-5v4h5v5h4v-5h5z"
        fill="#fff"
      />
    </svg>
  );
}

export default CapacityBuildingIcon;
